import sectorsData from '../data/sectors.json';

// Récupère tous les secteurs pour une entreprise donnée (l2mi ou airmetrologie)
export const getSectors = (company) => {
  return sectorsData[company]?.sectors || [];
};

// Trouve un secteur et ses sous-secteurs par ID
export const findSectorById = (company, sectorId) => {
  const sectors = getSectors(company);
  
  // Fonction récursive pour chercher dans l'arborescence
  const findInSectors = (sectors, id) => {
    for (const sector of sectors) {
      if (sector.id === id) {
        return sector;
      }
      if (sector.subSectors) {
        const found = findInSectors(sector.subSectors, id);
        if (found) return found;
      }
    }
    return null;
  };

  return findInSectors(sectors, sectorId);
};

// Récupère les accréditations pour un secteur donné
export const getAccreditationsForSector = (company, sectorId) => {
  const sector = findSectorById(company, sectorId);
  if (!sector) return [];

  return sector.accreditations || [];
};

// Récupère les accréditations en remontant la hiérarchie si nécessaire
export const getInheritedAccreditations = (company, sectorId) => {
  const sectors = getSectors(company);
  
  // Fonction pour obtenir l'ID du parent
  const getParentId = (id) => {
    const parts = id.split('_');
    return parts.slice(0, -1).join('_');
  };

  // Cherche les accréditations en remontant la hiérarchie
  let currentId = sectorId;
  while (currentId) {
    const accreditations = getAccreditationsForSector(company, currentId);
    if (accreditations.length > 0) {
      return {
        sectorId: currentId,
        accreditations: accreditations
      };
    }
    currentId = getParentId(currentId);
  }

  return {
    sectorId: sectorId,
    accreditations: []
  };
};

// Vérifie si un secteur a des sous-secteurs
export const hasSubSectors = (sector) => {
  return sector && Array.isArray(sector.subSectors) && sector.subSectors.length > 0;
};
